'use strict';

paging.$inject = ["Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paging = paging;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function paging(Enums) {
    var clazz = function Paging() {
        var defaults = {
            totalItems: 0,
            itemsPerPage: Enums.getAmounts.default,
            page: 1,
            pageCount: 1,
            pageNumbers: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        update: function update(page) {
            this.pageCount = this.getPageCount();
            this.pageNumbers = this.getPageNumbers(page);
        },
        getPageCount: function getPageCount() {
            return Math.floor((this.totalItems + this.itemsPerPage - 1) / this.itemsPerPage);
        },
        getPageNumbers: function getPageNumbers(page) {
            var pageCount = this.getPageCount();
            var pageObjects = [];

            if (pageCount <= 5) {
                for (var i = 1; i <= pageCount; i++) {
                    pageObjects.push({ index: i, isHiddenOnMobile: false });
                }
            } else {
                // when current page is 1, 2 or 3
                // - show 1 2 3 4 at the beginning (on mobile: hide 4)
                // - add ellipses
                // - add n
                if (page === 1 || page === 2 || page === 3) {
                    pageObjects.push({ index: 1, isHiddenOnMobile: false });
                    pageObjects.push({ index: 2, isHiddenOnMobile: false });
                    pageObjects.push({ index: 3, isHiddenOnMobile: false });
                    pageObjects.push({ index: 4, isHiddenOnMobile: true });
                    pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                    pageObjects.push({ index: pageCount, isHiddenOnMobile: false });
                }

                // when current page is n, n-1, n-2
                // add 1
                // - add ellipses
                // - show n-3 n-2 n-1 n at the end (on mobile: hide n-3)
                else if (page === pageCount || page === pageCount - 1 || page === pageCount - 2) {
                        pageObjects.push({ index: 1, isHiddenOnMobile: false });
                        pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                        pageObjects.push({ index: pageCount - 3, isHiddenOnMobile: true });
                        pageObjects.push({ index: pageCount - 2, isHiddenOnMobile: false });
                        pageObjects.push({ index: pageCount - 1, isHiddenOnMobile: false });
                        pageObjects.push({ index: pageCount, isHiddenOnMobile: false });
                    }

                    // when current page (p) is anything else
                    // - add 1
                    // - add ellipses
                    // - add p-1 p p+1 (on mobile: hide p-1 and p+1)
                    // - add ellipses
                    // - add n
                    else {
                            pageObjects.push({ index: 1, isHiddenOnMobile: false });
                            pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                            pageObjects.push({ index: page - 1, isHiddenOnMobile: true });
                            pageObjects.push({ index: page, isHiddenOnMobile: false });
                            pageObjects.push({ index: page + 1, isHiddenOnMobile: true });
                            pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                            pageObjects.push({ index: pageCount, isHiddenOnMobile: false });
                        }
            }

            return pageObjects;
        },
        getSkipValue: function getSkipValue(page, itemsPerPage) {
            return (page - 1) * itemsPerPage;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.totalItems = resource.totalItems;
        o.itemsPerPage = resource.itemsPerPage;
        o.page = resource.page;
        o.pageCount = o.getPageCount();
        o.pageNumbers = o.getPageNumbers(o.page);
        return o;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/pagingModel.js
// module id = 769
// module chunks = 0